(function () {
    const desktopBreakpoint = 1200;
    let isMobile =  window.innerWidth < desktopBreakpoint;
    const segmentSliders = Array.from(document.querySelectorAll(".plug-seg-c__segment plug-slider"));

    const handleResize = () => {
        const wasMobile = isMobile;
        isMobile = window.innerWidth < desktopBreakpoint;
        if (wasMobile !== isMobile) {
            segmentSliders.forEach(slider => {
                if (isMobile) {
                    slider.initSlider();
                } else {
                    slider.destroySlider();
                }
            });
        }
    };

    class PlugSlider extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            if (!window.Swiper) {
                console.error("PLUG: Swiper.js is not loaded. Please include Swiper.js to use the plug-logo-bar component.");
                return this.hideSection();
            }

            this.sliderId = this.dataset.sliderId;

            this.elements = {
                swiper: document.getElementById(this.sliderId),
                swiperWrapper: this.querySelector(".swiper-wrapper"),
                slides: this.querySelectorAll(".swiper-slide"),
            };

            if (!this.sliderId || !this.elements.swiper) {
                console.error("PLUG: Swiper element cannot be found.");
                return this.hideSection();
            }

            this.initSlider();
        }

        initSlider() {
            if (this.slider || (this.closest(".plug-seg-c__segment") && !isMobile)) {
                return;
            }

            const defaultSettings = {
                a11y: true,
                centerInsufficientSlides: false,
                grabCursor: true,
                slidesPerView: "auto",
            };

            const settingsScript = this.querySelector("script[data-slider-custom-settings]");
            const customSettings = (
                settingsScript
                    ? JSON.parse(settingsScript.innerHTML)
                    : {}
            );

            this.swiper = new Swiper(
                `#${this.sliderId}`,
                Object.assign(defaultSettings, customSettings)
            );

            if (this.classList.contains("is-transparent")) {
                window.requestAnimationFrame(() => {
                    setTimeout(() => {
                        this.classList.remove("is-transparent");
                    }, 0);
                });
            }
        }

        disconnectedCallback() {
            this.destroySlider();
        }

        hideSection() {
            const section = this.closest(".plug-section");
            if (section) {
                section.style.display = "none";
            }
        }

        destroySlider() {
            // Triggered when mobile/desktop breakpoint is crossed.
            if (this.swiper && typeof this.swiper.destroy === "function") {
                this.swiper.destroy();
            }
        }
    }
    if (!customElements.get("plug-slider")) {
        customElements.define("plug-slider", PlugSlider);
    }

    let timer;
    window.addEventListener("resize", () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            handleResize();
        }, 500);
    });
})();
